module.exports = __webpack_public_path__ + "img/code-security.0f9afadb.png";